// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__45wXv","title":"ClientCherryInfo_title__3aKd3","itemText":"ClientCherryInfo_itemText__3bC2I"};